import { render } from "./paymentRelated.vue?vue&type=template&id=352c511d&scoped=true"
import script from "./paymentRelated.vue?vue&type=script&lang=js"
export * from "./paymentRelated.vue?vue&type=script&lang=js"

import "./paymentRelated.vue?vue&type=style&index=0&id=352c511d&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352c511d"]])

export default __exports__